// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_T_A","cls2":"Unibrow-cls2_ZJ3 Unibrow-cls1_T_A"};